const Page : React.FC = ({ children }) => (
    <div className="container-page">
        { children }
    </div>
);

export default Page;